import { createElement } from '../utils/dom.js';
import { iconTrash } from '../utils/icons.js';

const CHECKMARK_SVG = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>`;

/**
 * Rend un article de la liste de courses.
 * @param {{ id: number, name: string, quantity: number, checked: boolean, aisleId?: number|null }} item
 * @param {{ onToggle: (id: number) => void, onDelete: (id: number) => void, onQuantityChange: (id: number, qty: number) => void }} callbacks
 * @returns {HTMLElement}
 */
export function renderArticleItem(item, { onToggle, onDelete, onQuantityChange }) {
  const article = createElement('div', {
    className: `article-item${item.checked ? ' article-item--checked' : ''}`,
  });

  const checkbox = createElement('label', { className: 'article-item__checkbox' });
  const checkboxInput = createElement('input', {
    attrs: { type: 'checkbox', ...(item.checked ? { checked: 'checked' } : {}) },
    events: {
      change: () => onToggle(item.id),
    },
  });
  const checkboxMark = createElement('span', {
    className: 'article-item__checkbox-mark',
    html: CHECKMARK_SVG,
  });
  checkbox.append(checkboxInput, checkboxMark);

  const name = createElement('span', {
    className: 'article-item__name',
    text: item.name,
  });

  const quantityBadge = createElement('button', {
    className: 'badge badge--quantity article-item__quantity',
    attrs: { type: 'button', 'aria-label': `Quantité : ${item.quantity}` },
    text: String(item.quantity),
    events: {
      click: (e) => {
        e.stopPropagation();
        const newQty = prompt('Nouvelle quantité :', String(item.quantity));
        if (newQty === null) return;
        const parsed = parseInt(newQty, 10);
        if (!Number.isNaN(parsed) && parsed > 0) {
          onQuantityChange(item.id, parsed);
        }
      },
    },
  });

  const deleteBtn = createElement('button', {
    className: 'btn btn--icon btn--icon-danger article-item__delete',
    attrs: { type: 'button', 'aria-label': 'Supprimer' },
    children: [iconTrash(18)],
    events: {
      click: (e) => {
        e.stopPropagation();
        onDelete(item.id);
      },
    },
  });

  const content = createElement('div', {
    className: 'article-item__content',
    children: [checkbox, name, quantityBadge],
  });

  article.append(content, deleteBtn);
  return article;
}
